// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../css-loader/dist/cjs.js??ref--3-oneOf-1-3!../../postcss-loader/src/index.js??ref--3-oneOf-1-4!./swiper.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../vue-style-loader/lib/addStylesClient.js").default
var update = add("2399ed38", content, true, {"sourceMap":false});